export default __webpack_public_path__ + "static/media/32.ac68e261.png";